// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-64d83ddd] .collapsed > .when-open,[data-v-64d83ddd] .not-collapsed > .when-closed {\n  display: none;\n}\n[data-v-64d83ddd] .collapse-button {\n  background-color: inherit;\n  color: #656565;\n  border: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
